/**
 * The renderer heartbeat the kiosk watchdog reads (D15).
 *
 * `ops/pi-kiosk/kiosk-health.sh` probes the DevTools `/json` endpoint and parses
 * the page title as exactly `l42hb:<unix epoch seconds>`. On modern Chromium
 * that title is the only thing distinguishing a live player from an error page
 * or a frozen renderer: an error page keeps the original URL. A title that
 * stops advancing — a hung main thread does not run timers — reads as stale and
 * the watchdog restarts the browser.
 *
 * Started app-wide, not on the playback view, so a screen sitting on the
 * pairing code is healthy too.
 */
export const TITLE_HEARTBEAT_INTERVAL_MS = 30_000;

export function titleHeartbeat(nowMs: number = Date.now()): string {
  return `l42hb:${Math.floor(nowMs / 1000)}`;
}

export function startTitleHeartbeat(intervalMs = TITLE_HEARTBEAT_INTERVAL_MS): () => void {
  const beat = (): void => {
    document.title = titleHeartbeat();
  };
  beat();
  const timer = setInterval(beat, intervalMs);
  return () => clearInterval(timer);
}
